import React, { Component } from 'react';
import PropTypes from 'prop-types';
import brandingStyles from '../branding/brandingStyles';

class Selector extends Component {

    constructor(props) {
        super(props);
        this.handleValueSelection = this.handleValueSelection.bind(this);
    }

    handleValueSelection(event) {
        this.props.selectValue(event.target.value);
    }

    render() {
        return (
          <select
            className="form-control pull-right"
            style={Object.assign(
              { width: 'auto' },
              brandingStyles.buttons.primary
            )}
            value={this.props.selected}
            onChange={this.handleValueSelection}
          >
            {this.props.values.map(
              value => (
                <option
                  key={value.id}
                  value={value.value}
                >
                  {value.label}
                </option>
              ))}
          </select>
        );
    }

}

Selector.propTypes = {
    values: PropTypes.array.isRequired,
    selected: PropTypes.string.isRequired,
    selectValue: PropTypes.func.isRequired,
};

export default Selector;



/** WEBPACK FOOTER **
 ** ./src/utils/Selector.js
 **/